<template>
  <Content id="lisProject">
    <div slot="search">
      <Form :label-width="50" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="名称"><Input v-model="search.name" maxlength="50"/></FormItem></Col>
          <Col><FormItem label="编码"><Input v-model="search.code" maxlength="50"/></FormItem></Col>
          <Col>
            <FormItem label="类型">
              <Select v-model="search.type" style="min-width: 75px;" :clearable="true">
                <Option v-for="item in enums.lisTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血试管" :label-width="75">
              <Select v-model="search.bloodTubeId" style="min-width: 75px;" :clearable="true">
                <Option v-for="item in bloodTubeList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <!--
          <Col>
            <FormItem label="送检机构" :label-width="75">
              <Select v-model="search.inspectOrganizeId">
                <Option v-for="item in inspectOrganizeList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          -->
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="min-width: 75px;" :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
          <Button size="small" style="margin-left: 5px;" icon="ios-paper-outline" @click="handleCopy" type="primary">复制模版</Button>
        </div>
      </div>
    </div>

    <Row :gutter="24" class="tableCell" style="margin-bottom: 10px;margin-left: 2px;margin-right: 10px;">
      <Col class="col-cell" v-for="(item, index) in [24]" :span="item" style="border: #ffe8c5 solid 1px;height:35px;line-height:35px;background-color: #fff9f0;">
        <slot v-for="i in 1" :name="'inner'+i" v-if="(index+1) == i">
          <Icon type="ios-cube"/><span style="text-align: left;color: #f3673d;margin-right: 5px;"> 鼠标长按上下拖动可以调整排序</span>
        </slot>
      </Col>
    </Row>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background: '#f8f8f9', color: '#515a6e', 'text-align': 'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column prop="name" align="center" label="项目名称" show-overflow-tooltip  min-width="200"/>
      <el-table-column align="center" prop="code" label="编码"  min-width="100"/>
      <el-table-column align="center" prop="type" label="项目类型"  min-width="80">
        <template slot-scope="scope">{{ enums.lisTypes.filter(u => u.value === scope.row.type)[0].label }}</template>
      </el-table-column>
      <el-table-column align="center" prop="bloodTubeId" label="抽血试管"  min-width="120">
        <template slot-scope="scope">
          <span :style="{'color': convertBloodTube(scope.row.bloodTubeId).color}">{{scope.row.bloodTubeName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="subCode" label="金域标本子码"  min-width="100"/>
      <el-table-column align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="150">
        <template slot-scope="scope">
          <el-button type="text" size="medium" @click="handleEdit(scope.row)" v-if="scope.row.level === 1">编辑</el-button>
          <el-button type="text" size="medium" @click="handleChildEdit(scope.row)" v-if="scope.row.level === 2">编辑</el-button>
          <el-button type="text" size="medium" @click="handleAddChlid(scope.row)" v-if="scope.row.level === 1">新增下级</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Modal v-model="dialogVisible" :title="dialogTitle" style="top:60px;text-align:center;" width="35%" :mask-closable="false" :max-height="maxHeight">
      <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入" v-model="lisProjectIds" :data="tempalteList"/>
      <div slot="footer">
        <Button @click="dialogVisible = false">取消</Button>
        <Button type="primary" @click="saveTempalte" :disabled="importDisabled">确定</Button>
      </div>
    </Modal>

    <Modal v-model="editWindow" width="45%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <LisProjectEdit ref="edit" :style="{'max-height':maxHeight, 'overflow-y': 'auto'}" :blood-tube-list="bloodTubeList"
                      :inspect-organize-list="inspectOrganizeList"  @on-submit="handleSubmit" />
      <div slot="footer">
        <Button @click="editWindow = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>

    <Modal v-model="childWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <LisProjectChild ref="child" :style="{'overflow-y': 'auto', 'height': '300px'}"
                       :lisProjectId="lisProjectId" :lisProjectName="lisProjectName" :lisProjectCode="lisProjectCode"
                       :bloodTubeName="bloodTubeName" :inspectOrganizeName="inspectOrganizeName" @on-submit="handleSubmit" />
      <div slot="footer">
        <Button @click="childWindow = false">取消</Button>
        <Button type="primary" @click="childSubmit">确定</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {
  _search, _updateStatus, _generalLisProject, _copyLisProject, _updateSort} from "@/services/screeningConfig/lisProject.js";
import {_updateOptionStatus} from "@/services/screeningConfig/lisOption.js";
import { mixins } from "@/mixins/index.js";
import LisProjectEdit from "./LisProjectEdit";
import LisProjectChild from "./LisProjectChild";
import {enums} from "@/services/enums";
import Sortable from "sortablejs";
export default {
  name: "LisProject",
  components: {
    LisProjectEdit,LisProjectChild
  },
  mixins: [mixins],
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      maxHeight: 0,
      currentRowIndex: null,
      search: {
        name: "",
        code: "",
        type: "",
        bloodTubeId: "",
        inspectOrganizeId: "",
        status:1
      },
      lisProjectId:"",
      lisProjectName:"",
      lisProjectCode:"",
      bloodTubeName:"",
      inspectOrganizeName:"",
      lisProjectIds:[],
      tempalteList:[],
      dialogTitle:"模版详情",
      dialogVisible: false,
      importDisabled: false,
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      editWindow:false,
      childWindow:false,
      windowTitle:"新增Lis项目",
      enums: enums,
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  async mounted() {
    this.bloodTubeList = await this.applyBloodTubeList();
    this.generalLisProject();

    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.inspectOrganizeList = await this.applyInspectOrganizeList();
    }

    this.$nextTick(() => {
      this.rowDrop();
    });
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
      this.maxHeight = `${height - 300}px`;
    },
    convertBloodTube(bloodTubeId){
      if(bloodTubeId == 1){
        return {color:'#CE1616',name:"红管"};
      }else if(bloodTubeId == 2){
        return {color:'#16B94E',name:"绿管"};
      }else if(bloodTubeId == 3){
        return {color:'#540BA2',name:"紫管"}
      }else if(bloodTubeId == 4){
        return {color:'#006DFD',name:"蓝管"}
      }else if(bloodTubeId == 5){
        return {color:'rgb(16,15,15)',name:"黑管"};
      }else if(bloodTubeId == 6){
        return {color:'#BDAE0C',name:"黄管"}
      }else if(bloodTubeId == 7){
        return {color:'#9BA0AB',name:"灰管"}
      }else if(bloodTubeId == 8){
        return {color:'#BF7007',name:"橙管"}
      }else if(bloodTubeId == 9){
        return {color:'#CE1616',name:"红管"};
      }else if(bloodTubeId == 10){
        return {color:'#CE1616',name:"红管"};
      }
    },
    generalLisProject(){
      this.tempalteList = [];
      _generalLisProject().then(res => {
        if (res.errcode === 1) {
          res.data.forEach((item, index) => {
            this.tempalteList.push({
              label: item.name,
              key: item.id
            });
          });
        }else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    saveTempalte(){
      if(!this.lisProjectIds||this.lisProjectIds.length==0){
        this.$message.warning('请先选择');
        return;
      }

      this.importDisabled = true;
      _copyLisProject({lisProjectIds:this.lisProjectIds}).then(res => {
        if (res.errcode === 1) {
          this.$message.success("复制成功");
          this.handleDataList();
          this.dialogVisible = false;
          this.importDisabled = false;
        }else {
          this.importDisabled = false;
          this.$message.error(res.errmsg);
        }
      }).catch(res=>{
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    handleCopy() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.importDisabled = false;
      this.dialogVisible = true;
      this.lisProjectIds = [];

      /*_copyLisProject().then(res => {
        if (res.errcode === 1) {
          this.$message.success("复制成功");
          this.handleDataList();
        }
      }).catch(() => {});*/
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _search({
        ...this.search,
      }).then(res => {
        if (res.errcode === 1 && res.data) {
          this.dataList = res.data;
        }
      }).catch(() => {});
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    childSubmit(){
      this.$refs['child'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.childWindow = result;
        this.handleDataList();
      }
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增Lis项目";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑Lis项目";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    handleChildEdit(row) {
      this.lisProjectId = row.lisProjectId;
      this.lisProjectName = row.name;
      this.lisProjectCode = row.code;
      this.bloodTubeName = row.bloodTubeName;
      this.inspectOrganizeName = row.inspectOrganizeName;
      this.windowTitle = "编辑下级";
      this.childWindow = true;
      this.$refs["child"].handleModal(false, row);
    },
    handleAddChlid(row){
      this.lisProjectId = row.id;
      this.lisProjectName = row.name;
      this.lisProjectCode = row.code;
      this.bloodTubeName = row.bloodTubeName;
      this.inspectOrganizeName = row.inspectOrganizeName;
      this.windowTitle = "新增下级";
      this.childWindow = true;
      this.$refs["child"].handleModal(true, row);
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            if(row.level === 1){
              this.updateProjectStatus(row, targetValue, resolve,reject);
            }else{
              this.updateOptionStatus(row, targetValue, resolve,reject);
            }
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    updateProjectStatus(row, targetValue, resolve,reject){
      _updateStatus({id:row.id, status: targetValue}).then(res =>{
        if (res.errcode === 1) {
          this.handleDataList();
        }else {
          this.$message.error(res.errmsg);
          reject()
        }
      }).catch(() => {
        reject()
      });
    },
    updateOptionStatus(row, targetValue, resolve,reject){
      _updateOptionStatus({id:row.id, status: targetValue}).then(res =>{
        if (res.errcode === 1) {
          this.handleDataList();
        }else {
          this.$message.error(res.errmsg);
          reject()
        }
      }).catch(() => {
        reject()
      });
    },
    rowDrop() {
      // const tbody = document.querySelector(".el-table__fixed-body-wrapper tbody");
      const table = this.$refs.singleTable.$el;
      // 主表格体
      const mainTbody = table.querySelector('.el-table__body-wrapper tbody');
      // 左侧固定列的表格体（如果存在）
      const fixedTbody = table.querySelector('.el-table__fixed-body-wrapper tbody');

      [mainTbody, fixedTbody].forEach(tbody => {
        if (tbody) {
          Sortable.create(tbody, {
            // boolean 定义是否此sortable对象是否可用，为true时sortable对象不能拖放排序等功能，为false时为可以进行排序，相当于一个开关；
            disabled: false,
            //拖拽动画(毫秒)
            animation: 600,
            ghostClass: 'sortable-ghost', // 拖拽时占位符的样式:cite[2]:cite[6]
            // 结束拖拽
            onEnd: ({ oldIndex, newIndex }) => {
              let data = [...this.dataList];
              const currRow = data.splice(oldIndex, 1)[0];
              data.splice(newIndex, 0, currRow);
              this.dataList = [];
              this.$nextTick(() => {
                this.dataList = data;
              });

              let updateData = data.map((item, index) => {
                item.sorts = this.pageList.pageSize * (this.pageList.currentPage - 1) +  (index + 1);
                return item;
              });
              this.updateSort(updateData);
              this.$forceUpdate();
            },
          });
        }
      });
    },
    updateSort(data) {
      _updateSort(data).then(res => {
        if(res && res.errcode == 1){
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {
      });
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-transfer-panel .el-transfer-panel__header {text-align: left;}
/deep/ .el-transfer-panel__list.is-filterable {text-align: left;}

</style>
